import { SHOW_SIGNUP_TO_UPGRADE_MODAL_EVENT_KEY } from './SignupToUpgradeModal';

const showSignupToUpgradeModal = () => {
  window.dispatchEvent(new Event(SHOW_SIGNUP_TO_UPGRADE_MODAL_EVENT_KEY));
};

export { showSignupToUpgradeModal };
